import { render, staticRenderFns } from "./VersionTabPanelPage.vue?vue&type=template&id=4f14ffc3&"
import script from "./VersionTabPanelPage.vue?vue&type=script&lang=js&"
export * from "./VersionTabPanelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports